import {PageTitle} from '../../../_metronic/layout/core';
import {useIntl} from 'react-intl';
import Telephonie from '../Components/Telephonie';
import {useGetTelephonieServices} from '../Hooks/TelephonieManager';

const TelephoniePage = (): JSX.Element => {
  const intl = useIntl();
  const {isLoading, data: services} = useGetTelephonieServices();

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.TELEPHONY'})}</PageTitle>
      <Telephonie isLoading={isLoading} services={services} />
    </>
  );
};

export default TelephoniePage;
